import React, { useState, useRef, useEffect, useContext } from "react";
import { FaSignOutAlt, FaUser } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { showLogoutAlert } from "../../src/utils";
import profileLogo from "../assets/images/profile-logo.jpg";
import mobileIcon from "../assets/images/mobile-icon.svg";
import emailIcon from "../assets/images/email-icon.svg";
import userIcon from "../assets/images/user-icon.svg";
import bamLogo from "../assets/images/bam-logo.svg";
import notificationIcon from "../assets/images/notification_icon.svg";
import notification from "../assets/images/notification.svg";
import arrowIcon from "../assets/images/arrow_icon.svg";
import Select from "react-select";
import { SUBDOMAIN, ROOT_DOMAIN, ROOT_URL, glocalLogoutUrl } from "../config/constant";
import { AiOutlineBell, AiOutlineMail, AiOutlinePhone } from "react-icons/ai";
import { getNotificationList, glocalLogoutHandler, changeNotificationStatus, makeNotificationCountReset } from "../redux/slices/apiSlice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useApp } from "../utils/AppContext";
import InfiniteScroll from 'react-infinite-scroll-component';




const decodeJWT = (token) => {
  if (!token) return null;
  // Split the token into its parts (Header, Payload, Signature)
  const [header, payload, signature] = token.split(".");
  // Function to decode base64url to a regular base64
  const base64UrlToBase64 = (base64Url) => {
    return base64Url.replace(/-/g, "+").replace(/_/g, "/");
  };
  // Decode the payload (second part of the JWT)
  const decodedPayload = JSON.parse(atob(base64UrlToBase64(payload)));
  return decodedPayload;
};

const Header = ({ user }) => {
  const navigate = useNavigate();

  const [toggleProfileMenu, setToggleProfileMenu] = useState(false);
  const [toggleNotificationMenu, setToggleNotificationMenu] = useState(false);
  const [accountsList, setAccountsList] = useState([]);
  const profileMenuRef = useRef(null);
  const dispatch = useDispatch();
  const [notificationList, setNotificationList] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [page, setPage] = useState(2);
  const [pageSize, setPageSize] = useState(10);
  const [hasMoreNotifications, setHasMoreNotifications] = useState(true);

  const fetchMoreNotifications = async () => {


    try {
      const response = await dispatch(getNotificationList({ page, limit: pageSize }));


      let newNotifications = response?.payload?.data;


      setNotificationList(prev => [...prev, ...newNotifications]);
      setPage(prev => prev + 1);
      setHasMoreNotifications(newNotifications.length > 0); // set to false when there's no more



      // setNotificationList(newNotifications);
      setUnreadCount(response?.payload?.notificationUnreadCount);
    } catch (error) {
      console.error("Error fetching data:", error);
    }



  };





  const handleUserProfile = () => {
    setToggleProfileMenu(!toggleProfileMenu);
    setToggleNotificationMenu(!toggleNotificationMenu);
  };
  const handleClickOutside = (event) => {
    if (
      profileMenuRef.current &&
      !profileMenuRef.current.contains(event.target)
    ) {
      setToggleProfileMenu(false);
      setToggleNotificationMenu(false);
    }
  };
  const { notificationCreativePayload, setNotificationCreativePayload } = useApp();

  const token = sessionStorage.getItem("token");
  useEffect(() => {
    const decodedToken = decodeJWT(token);
    if (decodedToken) {
      const clients = JSON.parse(decodedToken["custom:clients"]);
      setAccountsList(clients[0].services);
    }
  }, [token]);



  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await dispatch(getNotificationList({ page: 1, limit: pageSize }));

        let newNotifications = response?.payload?.data;

        setNotificationList(newNotifications);
        setUnreadCount(response?.payload?.notificationUnreadCount);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const deleteCookiesForDomain = (domain) => {
    const cookies = document.cookie.split(";");
    for (let cookie of cookies) {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${domain}`;
    }
  };

  const clearSessionStorage = () => {
    sessionStorage.clear();
  };

  const onClickSignout = async () => {
    const shouldLogout = await showLogoutAlert({
      title: <span className="text-[18px]">Logout</span>,
      text: "Are you sure you want to logout?",
      cancelButtonText: "Cancel",
      confirmButtonText: "Logout",
    });

    if (shouldLogout) {
      // const response = await dispatch(glocalLogoutHandler());

      deleteCookiesForDomain(SUBDOMAIN);
      clearSessionStorage();

      deleteCookiesForDomain(ROOT_DOMAIN);

      localStorage.clear();

      window.location.href = glocalLogoutUrl; // ROOT_URL;
    }
  };

  const openProfileSection = () => {
    setToggleProfileMenu(false);
  };
  const openNotificationSection = () => {
    setToggleNotificationMenu(false);
  };
  const reactSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      fontSize: "12px",
    }),
    input: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
    menu: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
    menuList: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: "12px",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };
  return (
    <div className="header-main">
      <div className="header-left">
        <img src={bamLogo} alt="logo" className="bam_logo" />
        {/* <React.Fragment>
          <div className=''>
            <Select
              options={accountsList}
              // value={selectedAdsAccount}
              // onChange={setSelectedAdsAccount}
              placeholder='Select Account'
              isClearable
              styles={reactSelectStyles}
            />
          </div>
        </React.Fragment> */}
      </div>
      <div className="header-right" ref={profileMenuRef}>
        {/* <span>
          <svg
            width="57"
            height="48"
            viewBox="0 0 57 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M29.4276 28.5692H28.999V22.4978C28.999 19.9781 27.1365 17.896 24.7133 17.5496V16.8549C24.7133 16.4603 24.3937 16.1406 23.999 16.1406C23.6044 16.1406 23.2847 16.4603 23.2847 16.8549V17.5496C20.8615 17.896 18.999 19.9781 18.999 22.4978V28.5692H18.5705C18.2544 28.5692 17.999 28.8246 17.999 29.1406V29.7121C17.999 29.7906 18.0633 29.8549 18.1419 29.8549H21.999C21.999 30.9585 22.8955 31.8549 23.999 31.8549C25.1026 31.8549 25.999 30.9585 25.999 29.8549H29.8562C29.9347 29.8549 29.999 29.7906 29.999 29.7121V29.1406C29.999 28.8246 29.7437 28.5692 29.4276 28.5692ZM23.999 30.7121C23.5258 30.7121 23.1419 30.3281 23.1419 29.8549H24.8562C24.8562 30.3281 24.4722 30.7121 23.999 30.7121ZM20.2847 28.5692V22.4978C20.2847 21.5049 20.6705 20.5728 21.3722 19.871C22.074 19.1692 23.0062 18.7835 23.999 18.7835C24.9919 18.7835 25.924 19.1692 26.6258 19.871C27.3276 20.5728 27.7133 21.5049 27.7133 22.4978V28.5692H20.2847Z"
              fill="black"
              fillOpacity="0.85"
            />
            <rect
              width="31"
              height="20"
              transform="translate(25.999 2)"
              fill="white"
              fillOpacity="0.01"
            />
            <rect
              x="25.999"
              y="2"
              width="31"
              height="20"
              rx="10"
              fill="#FF4D4F"
            />
            <path
              d="M39.1084 17H37.4619V10.4551L35.3057 11.2285V9.81055L39.0205 8.46875H39.1084V17ZM46.3154 17H44.6689V10.4551L42.5127 11.2285V9.81055L46.2275 8.46875H46.3154V17Z"
              fill="white"
            />
          </svg>
        </span> */}
        <button type="button" onClick={() => { setUnreadCount(0);  dispatch(makeNotificationCountReset()); setToggleNotificationMenu(true); } }>
          <span className="notification">
            <img
              alt=""
              height="17px"
              width="15px"
              className="avtar"
              src={notificationIcon}
            />
            {unreadCount ? <em className="count">{unreadCount}</em> : <></>}
          </span>
        </button>
        {/* {notificationList?.length ? (
          <div
            className={`notification_drop ${toggleNotificationMenu ? "toggle-profile-menu" : ""
              }`}
          >
            <div class="notification_head">
              <img alt="" height="16px" width="12px" src={notification} />
              <h6>Notifications</h6>
            </div>
            <div className="notification_list_wrap">
              {notificationList.map((notification, index) => (
                <div key={index} className="notification_list"  onClick={() => {setNotificationCreativePayload(notification); navigate("/creative_approval"); setToggleNotificationMenu(false); }}>
                  <div className="notification_name_date">
                    <div className="name">{notification?.title}</div>
                    <div className="date">
                      {notification?.createdAt
                        ? moment(notification.createdAt).format(
                          "DD/MM/YYYY, hh:mm:ss A"
                        )
                        : ""}
                    </div>
                  </div>
                  <h6 className="notification_title">
                    {notification?.message}
                  </h6>
                   <a href="#" className="notification_btn">
                  Review Updates
                  <img alt="" height="7px" width="4px" src={arrowIcon} />
                </a> 
                </div>
              ))}
            </div>
          </div>
        ) : (
          <></>
        )} */}

        {notificationList?.length ? (
          <div
            className={`notification_drop ${toggleNotificationMenu ? "toggle-profile-menu" : ""}`}
          >
            <div className="notification_head">
              <img alt="" height="16px" width="12px" src={notification} />
              <h6>Notifications</h6>
            </div>

            <div className="notification_list_wrap" id="scrollableNotificationDiv" style={{ height: '300px', overflow: 'auto' }}>
              <InfiniteScroll
                dataLength={notificationList.length}
                next={fetchMoreNotifications}
                hasMore={hasMoreNotifications}
                loader={<p style={{ textAlign: 'center' }}>Loading...</p>}
                scrollableTarget="scrollableNotificationDiv"
              >
                {notificationList.map((notification, index) => (
                  <div
                    key={index}
                    className={`notification_list ${!notification?.isRead && "notification_unread"}`}
                    onClick={() => {
                      const updatedList = notificationList.map((item, i) =>
                        i === index ? { ...item, isRead: true } : item
                      );
                      setNotificationList(updatedList); 
                      setNotificationCreativePayload(notification);
                      if (notification?.creativeId) {
                        navigate("/creative_approval");
                        dispatch(changeNotificationStatus({ notificationId: notification?._id, isRead: true }));
                      }
                      setToggleNotificationMenu(false);
                    }}
                  >
                    <div className="notification_name_date">
                      <div className="name">{notification?.title}</div>
                      <div className="date">
                        {notification?.createdAt
                          ? moment(notification.createdAt).format("DD/MM/YYYY, hh:mm:ss A")
                          : ""}
                      </div>
                    </div>
                    <h6 className="notification_title">{notification?.message}</h6>
                  </div>
                ))}
              </InfiniteScroll>
              {
                !hasMoreNotifications &&
                <div className="notification_list">
                  That's all your notifications from the last 30 days.
                </div>
              }
            </div>
          </div>
        ) : null}


        <button type="button" onClick={() => setToggleProfileMenu(true)}>
          <span ref={profileMenuRef}>
            <img
              alt="User Avatar"
              height="17px"
              width="15px"
              className="avtar"
              src={user?.image || userIcon}
            />
          </span>
          <span>{user?.user_name || "NA"}</span>
        </button>
        <div
          className={`profile-menu ${toggleProfileMenu ? "toggle-profile-menu" : ""
            }`}
        >
          <div class="mx-3 pt-3 pb-3 border-b-2">
            <div class="textHeading">{user.user_name}</div>
            <div class="text-default mt-1 text-grey-text"></div>
            <div class="flex gap-1 items-center mt-2">
              <img
                alt=""
                height="12"
                width="12"
                src={user?.image || mobileIcon}
              />
              <div>+91 999-999-9999</div>
            </div>
            <div class="flex gap-1 items-center mt-2">
              <img
                alt="User Avatar"
                height="12"
                width="12"
                src={user?.image || emailIcon}
              />
              <div>{user.email}</div>
            </div>
          </div>
          <div class="logOutBtn" onClick={onClickSignout}>
            Logout
          </div>
          {/* <ul>
             <li onClick={openProfileSection}>
              <Link>
                <span>
                  <FaUser />
                </span>{' '}
                Profile
              </Link>
            </li>
            <li onClick={onClickSignout}>
              <Link>
                <span>
                  <FaSignOutAlt />
                </span>{' '}
                Sign Out
              </Link>
            </li> 
          </ul>*/}
        </div>
      </div>
    </div>
  );
};

export default Header;
